var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('span',{class:"badge badge-pill badge-status " + _vm.statusClass},[_vm._v(_vm._s(_vm.statusText))])])}
var staticRenderFns = []

export { render, staticRenderFns }